export default "__VITE_ASSET__Bt44pMn5__"